import * as React from 'react'
import { ArgsConsumer, Logger, RequestContext } from 'DVWebNodeUtils'
import { Subtract } from '../utils/utils'
export interface ILogger {
  logger: Logger
}

export interface ILoggerAndContext {
  logger: Logger
  context: RequestContext
}

export const withLogger = <P extends ILogger>(
  Component: React.ComponentType<P>
) => (props: Subtract<P, ILogger>) => (
  <ArgsConsumer>
    {({ logger }) =>
      <Component {...props as P} logger={logger} />
    }
  </ArgsConsumer>
)
